<template>
    <span v-if="geography" :class="className"> {{ getGeography }} {{ getCategoryName }} </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { getGeographyText } from '../../helpers';
import { firstCharToLower } from '@/helpers';
import { ITravelCardGeo } from '../../types';

const { t } = useI18n();

const props = withDefaults(defineProps<ITravelCardGeo>(), { className: 'text-caption text-medium-emphasis' });
const getGeography = computed(() => getGeographyText(props.geography, t('travelCard.allZones')));
const getCategoryName = computed(() => (props.categoryName ? `, ${firstCharToLower(props.categoryName)}` : ''));
</script>
